import React, { FunctionComponent } from 'react';
import { Button } from '@havenengineering/module-shared-owners-ui/dist/components/Button';

interface RefundChoiceProps {
  handleReturnToDashboard: () => void;
  handleStepChange: () => void;
}

export const RefundChoice: FunctionComponent<RefundChoiceProps> = ({
  handleReturnToDashboard,
  handleStepChange,
}) => {
  return (
    <div data-testid="refund-choice">
      <p className="owners-body">
        To be eligible for a refund, you’ll need to have a credit balance on
        your account that’s over £100. Approved refunds will be transferred
        directly to your bank account up to 28 working days after your
        application is approved.
        <br />
        <br />
        <strong>Is your account currently in credit £100 or more?</strong>
      </p>
      <Button variant="contained" fullWidth onClick={() => handleStepChange()}>
        Yes
      </Button>
      <Button
        fullWidth
        variant="outlined"
        onClick={() => handleReturnToDashboard()}
      >
        Return to dashboard
      </Button>
    </div>
  );
};
